import {jpBasePath} from "./_base";

export const jpPathCreateAcct = jpBasePath.appendPathSegment('/create-acct');